import React from 'react';
import { motion } from 'framer-motion';
import { Users, FileText, ShieldCheck } from 'lucide-react';
export function StorySection() {
  return <section className="bg-white py-20 px-4 text-black" data-id="element-240">
      <div className="container mx-auto max-w-6xl" data-id="element-241">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-16" data-id="element-242">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-243">
            Por qué creé este sistema
          </h2>
        </motion.div>

        <div className="flex flex-col lg:flex-row gap-12 items-center mb-16" data-id="element-244">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4
        }} className="w-full lg:w-1/3 flex flex-col items-center" data-id="element-245">
            <div className="w-full max-w-sm aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl mb-6" data-id="element-246">
              <img src="https://images.unsplash.com/photo-1504148455328-c376907d081c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Carpintero trabajando" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500" data-id="element-247" />
            </div>
            <div className="text-center" data-id="element-248">
              <h3 className="font-bold text-xl" data-id="element-249">Carlos M.</h3>
              <p className="text-gray-600 font-medium" data-id="element-250">
                Carpintero de aluminio · +15 años de experiencia
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.2
        }} className="w-full lg:w-2/3 space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-251">
            <p data-id="element-252">
              Hace 15 años, yo estaba exactamente donde estás vos hoy. Empecé mi
              taller con mucha ilusión, pero la realidad me golpeó rápido.
            </p>
            <p data-id="element-253">
              Me acuerdo patente de un trabajo de línea Módena donde calculé mal
              los descuentos. Corté todos los perfiles y cuando fui a armar,
              nada encajaba. Tuve que comprar material de nuevo. Ese mes trabajé
              gratis.
            </p>
            <p data-id="element-254">
              Me cansé de perder plata por errores tontos. Me cansé de pasar
              presupuestos a ojo y rogar que me quede algo de ganancia. Así que
              empecé a documentar todo. Cada descuento, cada medida, cada
              cálculo de vidrio, cada respuesta que me funcionaba para cerrar
              ventas por WhatsApp.
            </p>
            <p className="font-bold text-black text-xl border-l-4 border-[#D4A017] pl-4 py-2" data-id="element-255">
              Lo que empezó como un cuaderno manchado en mi taller, hoy es el
              sistema que usan más de 1.200 carpinteros en toda Argentina para
              no perder un peso más.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.4
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6 bg-[#0A0A0A] rounded-2xl p-8 shadow-xl" data-id="element-256">
          <div className="flex flex-col items-center text-center p-4" data-id="element-257">
            <Users className="w-10 h-10 text-[#D4A017] mb-3" data-id="element-258" />
            <span className="text-3xl font-black text-[#D4A017] mb-1" data-id="element-259">
              +1.200
            </span>
            <span className="text-white font-medium" data-id="element-260">Carpinteros</span>
          </div>
          <div className="flex flex-col items-center text-center p-4 md:border-x border-gray-800" data-id="element-261">
            <FileText className="w-10 h-10 text-[#D4A017] mb-3" data-id="element-262" />
            <span className="text-3xl font-black text-[#D4A017] mb-1" data-id="element-263">+6</span>
            <span className="text-white font-medium" data-id="element-264">Líneas Documentadas</span>
          </div>
          <div className="flex flex-col items-center text-center p-4" data-id="element-265">
            <ShieldCheck className="w-10 h-10 text-[#D4A017] mb-3" data-id="element-266" />
            <span className="text-3xl font-black text-[#D4A017] mb-1" data-id="element-267">
              7 Días
            </span>
            <span className="text-white font-medium" data-id="element-268">Garantía Total</span>
          </div>
        </motion.div>
      </div>
    </section>;
}